import { IUser } from '../../types/user.interface';
import { api } from '../api';

export interface IUpdateUserPayload {
  id: string;
  name?: string;
  email?: string;
  isuNumber?: number;
  isuGroup?: string;
  role?: string; // 'Student' | 'Mentor' | 'Teacher' | 'Admin'
}

export interface IUserSearchRequest {
  name?: string;
  email?: string;
  role?: string;
  isuGroup?: string;
  isuGroupExact?: boolean;
  isuNumber?: number;
  verified?: boolean;
  sortBy?: 'name'|'isuNumber'|'email'|'role'|'isuGroup'|'verified';
  sortDir?: 'asc'|'desc';
  pageNumber: number;
  pageSize: number;
}

export interface IUserPage {
  users: IUser[];
  number: number;
}

export const userApi = api.injectEndpoints({
  endpoints: builder => ({
    getUser: builder.query<IUser, void>({
      query: () => `/users`,
      providesTags: () => [{ type: 'User' }],
    }),
    getAllUsers: builder.query<IUser[], void>({
      query: () => `/users/all`,
      providesTags: () => [{ type: 'User' }],
    }),
    searchUsers: builder.query<IUserPage, IUserSearchRequest>({
      query: params => ({ url: `/users/search`, params }),
      providesTags: () => [{ type: 'User' }],
    }),
    updateUser: builder.mutation<void, IUpdateUserPayload>({
      query: ({ id, ...rest }) => ({
        url: `/users/${id}`,
        method: 'PUT',
        body: rest,
      }),
      invalidatesTags: ['User', 'UsersInGroup'],
    }),
    verifyUser: builder.mutation<void, { id: string }>({
      query: ({ id }) => ({
        url: `/users/${id}/verify`,
        method: 'PUT',
      }),
      invalidatesTags: ['User'],
    }),
    exportUsers: builder.query<Blob, void>({
      query: () => ({ url: `/users/export`, responseHandler: (response) => response.blob() }),
    }),
    createUser: builder.mutation<{ id: string }, { isuNumber: number; email: string; name: string; password: string; isuGroup: string; groupIds: string[] }>(
      {
        query: body => ({
          url: `/users`,
          method: 'POST',
          body,
        }),
        invalidatesTags: ['User'],
      }
    ),
    deleteUser: builder.mutation<void, { id: string }>(
      {
        query: ({ id }) => ({ url: `/users/${id}`, method: 'DELETE' }),
        invalidatesTags: ['User'],
      }
    ),
  }),
});
